import React from 'react';
import EdgePageFrame from '../EdgePageFrame';
import EdgeMiniCarousel from './EdgeMiniCarousel';
import EdgeMerchandise from './EdgeMerchandise';

const EdgeHome: React.FC = () => {
    return (
        <EdgePageFrame key={'edge'}>
            <div className='flex flex-col justify-center items-center md:flex-row md:justify-around gap-6 px-8'>
                <p className='text-gray-800 text-center md:text-left text-2xl text-grenze p-4'>Whether it's your very first minitature or your legion masterwork, Artisan's Edge craft supplies has you covered every step of the way.</p>
                <EdgeMiniCarousel />
            </div>
            <EdgeMerchandise />
        </EdgePageFrame>
    )
}

export default EdgeHome;